import { all, call, fork, put, takeEvery, takeLatest, select } from 'redux-saga/effects'
import { CourseRecomActionTypes } from './types'
import { ICourseRecom } from '../interface'
import { fetchError, fetchSuccess, selectCourse, courseSelected } from './actions'
import { callApi } from '../../utils/api'

//function* handleFetch(category: any) {
function* handleFetch(searchParams: any) {
  try {
    var courseId = searchParams.payload.courseId;
    var term = searchParams.payload.searchTerm;
    var profession = searchParams.payload.searchProfession;
    var country = searchParams.payload.searchCountry;
    var sorting = searchParams.payload.sorting;
    var offset = searchParams.payload.offset;
    var limit = searchParams.payload.limit;
    if (profession == "All") profession = "";
    if (profession == "All Profession") profession = "";
    if (country == "All") country = "";
    if (country == "All Country") country = "";

    var paramList = "";
    if (courseId != "" && courseId != undefined) {
      if (paramList != "") paramList += "&";
      paramList += "courseId=" + courseId;
    }
    if (term != "" && term != undefined) {
      if (paramList != "") paramList += "&";
      paramList += "term=" + term;
    }
    if (profession != "" && profession != undefined){
      if (paramList != "") paramList += "&";
      paramList += "profession="+profession;
    }
    if (country != "" && country != undefined){
      if (paramList != "") paramList += "&";
      paramList += "country="+country;
    }
    if (offset != "" && offset != undefined){
      if (paramList != "") paramList += "&";
      paramList += "offset="+offset;
    }
    if (limit != "" && limit != undefined){
      if (paramList != "") paramList += "&";
      paramList += "limit="+limit;
    }
    if (sorting != "" && sorting != undefined){
      if (paramList != "") paramList += "&";
      paramList += "orderby="+sorting;
    }

    var API_PATH = '/GetCourseList';
    if (paramList != "") {
      API_PATH += "?" + paramList;
    }

   // console.log("API_PATH" + API_PATH);

    var API_ENDPOINT = 'https://ultimatesprodevapi02.azurewebsites.net/';
    //const res = yield call(getCourses, category.payload)
    const res = yield call(callApi, 'get', API_ENDPOINT, API_PATH);

    if (res.isSuccess) {
      yield put(fetchSuccess(res))
    } else {
      yield put(fetchError(res.error))
    }
  } catch (err) {
    if (err instanceof Error && err.stack) {
      yield put(fetchError(err.stack))
    } else {
      yield put(fetchError('An unknown error occured.'))
    }
  }
}

function* watchFetchRequest() {
  yield takeEvery(CourseRecomActionTypes.FETCH_REQUEST, handleFetch)
}

function* CourseRecomSaga() {
  yield all([fork(watchFetchRequest)]);
}

export default CourseRecomSaga
